
import externalConfiguration from '../external-configuration';
import { avoidCache } from './utils';

import { legacyLoadVod } from './legacy-to-state';

function stringTimeToSeconds( str) {
  let time = str.split( ':').map( t => parseInt( t, 10)).slice(0,3);
  time = Array.from( Array( 3 - time.length), () => 0).concat( time);
  return time[0] * 60 * 60 + time[1] * 60 + time[2];
}

function parseVtt( text) {
  let timeElements = [];
  text.split( /\n\s*\n/).forEach( (tag,i) => {
    tag = tag.split( '\n');
    while( tag.length >= 2 && !/[\s0-9:]-->[\s0-9:]/.exec( tag[0])) tag = tag.slice(1);
    if( tag.length >= 2) {
      timeElements.push( {
        begin: stringTimeToSeconds( tag[0].split( /[\s]*-->[\s]*/)[0]),
        end: stringTimeToSeconds( tag[0].split( /[\s]*-->[\s]*/)[1]),
        text: tag.slice(1).join( '<br>'),
      });
    }
  });
  return timeElements;
}

function loadTaggingListTranscription( taggingOptions, taggingList, settings) {
  let promises = [];
  taggingList.forEach( taggingFile => {
    promises.push(
      fetch( taggingFile.url).then( response => response.text()).then( text => {
        return { label: taggingFile.name, tagging: parseVtt( text) };
      })
    );
  });
  return Promise.all( promises).then( transcriptions => {
    settings.taggings = {};
    transcriptions.forEach( (transcription, i) => {
      settings.taggings[ transcription.label] = transcription.tagging;
    });
    settings.taggingOptions = taggingOptions;
    settings.chapters = [];
    return settings;
  });
}

function loadTaggingTranscription( settings, user = undefined, taggingOptions = undefined) {
  let promiseOfTaggingOptions = Promise.resolve( taggingOptions);
  if( taggingOptions === undefined) {
    if( user === undefined) user = settings.user;
    promiseOfTaggingOptions = fetch( avoidCache( '/definition/globalUserConfig/' + user + '/tagging.json'))
        .then( response => response.json())
        .catch( () => Promise.resolve( { taggingStyle: 'default'}));
  }
  let promises = [];
  let promiseOfChapters;
  let usingChapters = false;
  settings.playlist[0].tracks.forEach( (track,i) => {
    if( track.kind === 'captions') {
      promises.push(
        fetch( track.file).then( (response) => {
          return response.text().then( (text) => {
            return  { label: track.label, tagging:  parseVtt( text) };
          });
        })
      );
    } else if( track.kind === 'chapters') {
      usingChapters = true;
      promiseOfChapters = fetch( track.file).then( (response) => {
        return response.text().then( (text) => {
          return parseVtt( text);
        });
      }).catch( () => Promise.resolve( []));
    }
  });
  return Promise.all( promises).then( (transcriptions) => {
    settings.taggings = {};
    transcriptions.forEach( (transcription,i) => {
      settings.taggings[ transcription.label] = transcription.tagging;
    });
    return promiseOfTaggingOptions.then( taggingOptions => {
      settings.taggingOptions = taggingOptions;
      if( usingChapters) {
        return promiseOfChapters.then( (chapters) => {
          settings.chapters = chapters;
          return settings;
        });
      }
      settings.chapters = [];
      return settings;
    });
  });
}

function taggingToState( id1, id2) {
  let settings = {
    legacy: true,
    visualizerType: 'Tagging',
  };
  let commonCustomProps = {
    hlshtml: true,
    primary: "flash",
    abouttext: externalConfiguration.defaultPlayerAboutText,
    aboutlink: externalConfiguration.defaultPlayerAboutLink,
    width: window.innerWidth * 0.64,
    height: window.innerHeight,
    advertising: { client: 'vast', },
  };
  settings.visualizerOptions = {
    onResize: ( state) => { state.customProps.width = window.innerWidth * 0.64; state.customProps.height = window.innerHeight; return state;},
  }
  return legacyLoadVod( id1, id2).then( (vodSettings) => {
    Object.assign( settings, vodSettings);
    Object.assign( settings.customProps, commonCustomProps);
    return loadTaggingTranscription( settings);
  });
}

export default taggingToState;
export { loadTaggingTranscription, loadTaggingListTranscription };



// WEBPACK FOOTER //
// ./src/helpers/tagging-to-state.js